import React from "react";
import { connect } from "react-redux";
import "./index.css";
import { bindActionCreators } from "redux";
import { withTranslation } from "react-i18next";
import Container from "@material-ui/core/Container";

import Benefit1 from "./../../resources/img/benefit/benefit_1.jpg";
import Benefit2 from "./../../resources/img/benefit/benefit_2.jpg";
import Benefit3 from "./../../resources/img/benefit/benefit_3.jpg";

import BenefitBy1 from "./../../resources/img/benefit/by/benefit_1.JPG";
import BenefitBy2 from "./../../resources/img/benefit/by/benefit_2.JPG";
import BenefitBy3 from "./../../resources/img/benefit/by/benefit_3.JPG";
import Typography from "@material-ui/core/Typography";

import Grid from "@material-ui/core/Grid";

class BenefitComponent extends React.Component {
  render() {
    const { t } = this.props;
    let domain = window.location.hostname.split(".")[
      window.location.hostname.split(".").length - 1
    ];
    // domain = "by";
    const reviewsSchema = {
      ua: [Benefit1, Benefit2, Benefit3],
      by: [BenefitBy1, BenefitBy2, BenefitBy3],
    };
    let array = reviewsSchema[domain]
      ? reviewsSchema[domain]
      : reviewsSchema["ua"];
    return (
      <>
        <section className="benefit">
          <Container fixed>
            <Grid container alignItems="center">
              <Grid item md={12} xs={12}>
                <Typography
                  variant="h6"
                  component="h3"
                  className="orange-texts"
                >
                  {t("benefit.title")}
                </Typography>
                <div className="benefit_subtitle">
                  <div></div>
                  {t("benefit.sub_title")}
                </div>
              </Grid>
              <Grid container>
                {array.map((el, index) => {
                  return (
                    <Grid item md={4} xs={12} key={index}>
                      <img alt="" src={el} />
                    </Grid>
                  );
                })}
                <Grid item md={12} xs={12}>
                  <div className="healthy_blocks-horizontal txt-green">
                    <p style={{ textAlign: "center" }}>{t("benefit.text")}</p>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Container>
          <Typography variant="h6" component="h3" className="full-width orange">
            {t("benefit.sub_block")}
          </Typography>
        </section>
      </>
    );
  }
}

const widthConnect = connect(
  (state) => ({}),
  (dispatch) => bindActionCreators({}, dispatch)
);

export default withTranslation()(widthConnect(BenefitComponent));
